import React from 'react'
import Countdown, { zeroPad } from 'react-countdown'

class CountdownTimer extends React.Component {
  constructor(props) {
    super(props)

    let { time } = this.props
    if (time === undefined) {
      time = 0
    }

    this.state = {
      time,
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.id !== nextProps.id) {
      this.setState({ time: nextProps.time })
    }
  }

  render() {
    return (
      <div className={this.props.className} id={this.props.id}>
        <h1 className="uk-text-bold uk-margin-remove">
          <Countdown
            key={this.props.id}
            date={Date.now() + (this.state.time * 1000)}
            renderer={
              ({ minutes, seconds }) => (
                <span>
                  {zeroPad(minutes, 0)}:{zeroPad(seconds, 2)}
                </span>
              )
            }
            onTick={() => {
              this.setState({ time: this.state.time - 1 }, () => {
                if (typeof this.props.onTick === 'function') {
                  this.props.onTick()
                }
              })
            }}
            onComplete={this.props.onComplete}
          />
        </h1>
      </div>
    )
  }
}

export default CountdownTimer
